<script>
  import { mdbNavbar, mdbNavbarBrand, mdbNavbarNav, mdbNavItem, mdbIcon } from 'mdbvue'
  export default {
    computed: {
      isUserLogged () {
        return this.$store.getters['user/IS_LOGGED']
      }
    },
    methods: {
      logout () {
        this.$store.dispatch('user/LOGOUT')
      }
    },
    components: {
      mdbNavbar,
      mdbNavbarBrand,
      mdbNavbarNav,
      mdbNavItem,
      mdbIcon,
      ReportsSearcher: () => import('@/components/reports/list/ReportsSearcher')
    }
  }
</script>

<template>
  <header class="app-header">
    <mdb-navbar position="top" dark color="primary" scrolling>
      <mdb-navbar-brand href="#">
        <strong>MP CRS</strong>
      </mdb-navbar-brand>
      <mdb-navbar-nav
        class="app-header__searcher-wrapper"
        right
        v-if="isUserLogged"
      >
        <ReportsSearcher center class="app-header__searcher-wrapper" />
      </mdb-navbar-nav>
      <mdb-navbar-nav right v-if="isUserLogged">
        <mdb-nav-item
          href="#"
          @click.prevent="logout"
          class="app-header__logout"
        >
          wyloguj
          <mdb-icon icon="sign-out-alt" />
        </mdb-nav-item>
      </mdb-navbar-nav>
    </mdb-navbar>
  </header>
</template>

<style lang="scss">
  @import 'src/sass/shared.scss';
  .app-header {
    .navbar-toggler {
      display: none;
    }
    &__searcher-wrapper {
      max-width: 160px;
    }
    &__logout {
      a {
        @include mediaMax(430px) {
          font-size: 0;
          .svg-inline--fa.fa-w-16 {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
</style>
